import { LANDSCAPE_LOGO } from '../../../../fields'
import { getImageAssetInitialValues } from '../../helpers'

export const getInitialValues = assets => {
  return {
    [LANDSCAPE_LOGO]: assets.map(asset => getImageAssetInitialValues(asset))
  }
}
